var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 20.0616C7.36425 20.7104 8.88975 21.0734 10.5 21.0734C12.1103 21.0734 13.6357 20.7104 15 20.0616V14.3234C15 13.7264 14.763 13.1541 14.3407 12.7326C13.9192 12.3104 13.347 12.0734 12.75 12.0734H8.25C7.653 12.0734 7.08075 12.3104 6.65925 12.7326C6.237 13.1541 6 13.7264 6 14.3234V20.0616ZM4.5 19.1894V14.3234C4.5 13.3289 4.89525 12.3749 5.598 11.6714C6.2295 11.0406 7.06275 10.6574 7.9455 10.5854C6.951 9.81961 6.309 8.61587 6.309 7.26437C6.309 4.95136 8.187 3.07336 10.5 3.07336C12.813 3.07336 14.691 4.95136 14.691 7.26437C14.691 8.61587 14.049 9.81961 13.0545 10.5854C13.9372 10.6574 14.7705 11.0406 15.402 11.6714C16.1047 12.3749 16.5 13.3289 16.5 14.3234V19.1894C19.2195 17.2911 21 14.1389 21 10.5734C21 4.77811 16.2952 0.0733643 10.5 0.0733643C4.70475 0.0733643 0 4.77811 0 10.5734C0 14.1389 1.7805 17.2911 4.5 19.1894ZM10.5 4.57336C11.985 4.57336 13.191 5.77937 13.191 7.26437C13.191 8.74936 11.985 9.95461 10.5 9.95461C9.015 9.95461 7.809 8.74936 7.809 7.26437C7.809 5.77937 9.015 4.57336 10.5 4.57336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.36b4847ee1df82a127604c63144de3fc.svg";
export { ForwardRef as ReactComponent };